<template>
  <div class="check-headset">
    <div class="title">
      <span>Keyboard Check</span>
      <span class="time">This screen is not timed</span>
    </div>
    <div class="body">
      <div class="info">
        <p>
          This is an opportunity to check that you have the correct keyboard.
        </p>
        <p>1 Look at the top row of letters on the keyboard.</p>
        <p>2 The letters should appear in this order Q W E R T Y</p>
        <p>
          3. If you do not have a QWERTY keyboard, raise your hand to get the
          attention of the Test Administrator.
        </p>
        <img
          src="https://ptegofeifan.oss-accelerate.aliyuncs.com/go/admin_file_1619418487544813048422.jpg"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  mounted() {
    this.SetTimeType({ type: 'NONE' })
  },
  methods: {
    ...mapActions('exam', ['SetTimeType'])
  }
}
</script>

<style scoped lang="scss">
.check-headset {
  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ebebf2;
    padding: 30px 0 10px;
    > span {
      color: #1f1f40;
      font-size: 20px;
      font-weight: bold;
    }
    .time {
      font-size: 14px;
    }
  }
  .body {
    display: flex;
    align-items: flex-start;
    .info {
      flex: 1;
      align-items: flex-start;
      margin-right: 20px;
      p {
        color: #1f1f40;
        font-size: 14px;
        line-height: 30px;
        > span {
          color: #ff606d;
          font-weight: bold;
        }
      }
      > img {
        margin-top: 10px;
      }
    }
  }
}
</style>
